exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.live-page .vc-day-content:focus {\n  background-color: #2a5b8f !important;\n  color: white !important;\n}\n", ""]);

// exports
